import { render, staticRenderFns } from "./user_edit_admin.vue?vue&type=template&id=47a0142c"
import script from "./user_edit_admin.vue?vue&type=script&lang=js"
export * from "./user_edit_admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports